import { dateFormat } from './index';
export const uuid = () => {
  var s = [];
  var hexDigits = '0123456789abcdef';
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(window.$Random01() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-';

  return s.join('');
};

//  生成随机16位id
export const generateUUID = () => {
  var d = new Date().getTime();
  return 'xxxxxxxxx4xxxyxx'.replace(/[xy]/g, function (c) {
    var r = (d + window.$Random01() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};

/**
 * @name 保留几位小数
 * @param fixed 默认2位
 */
export const getNumberToFixed = (value, fixed = 2) => {
  if (fixed == 2) {
    return Math.floor(value * 100) / 100;
  }
};

// 将数字转换为千分位 保留小数
export const dieThousandth = (num, decimal = 0) => {
  if (decimal) {
    num = Math.round(Number(num) * Math.pow(10, decimal)) / Math.pow(10, decimal);
    num = num.toFixed(decimal);
  }
  return (num + '').replace(/\-?\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
};

// 将数字转换为万单位和亿单位
export const dieThousandthUnit = (num, fixed = 2) => {
  if (num === '' || num === null || num === undefined) {
    return '--';
  }
  const moneyUnits = ['', '万', '亿', '万亿'];
  const dividend = 10000;
  let currentNum = num;
  // 转换数字
  let currentUnit = moneyUnits[0];
  // 转换单位
  for (let i = 0; i < 4; i++) {
    currentUnit = moneyUnits[i];
    const stringNum = currentNum.toString();
    const index = stringNum.indexOf('.');
    let newNum = stringNum;
    if (index !== -1) {
      newNum = stringNum.substring(0, index);
    }
    if (newNum.length < 5) {
      break;
    }
    currentNum = currentNum / dividend;
  }
  const m = { num: 0, unit: '' };
  // m.num = Math.round(currentNum * Math.pow(10, fixed)) / Math.pow(10, fixed);
  m.num = dieThousandth(currentNum, fixed);
  m.unit = currentUnit;
  return m.num + m.unit;
};

// 数值巨大，转换千分位带单位的数值
export const dieThousandthUnitTwo = (num, fixed = 2) => {
  const result = dieThousandthUnit(num, fixed);
  let value = result.match(/\-?(\d\.?)+/g) || [];
  const unit = result.match(/[\u4e00-\u9fa5]+/g) || [];
  return {
    value: value.join(''),
    unit: unit.join(''),
  };
};

/**
 * 数组对象键值排序
 * @param { } arr 数组
 * @param { } property 键值key
 * @param { } order 排序，默认升序
 */
export const sortByObjectKey = (arr, property, order = 'asc') => {
  function compare(key) {
    return (a, b) => {
      const value1 = a[key];
      const value2 = b[key];
      return order === 'asc' ? value1 - value2 : value2 - value1;
    };
  }
  return arr.sort(compare(property));
};

// 千分符后小数补位
const toDecimal2 = (num, value) => {
  let str = num === 0 && value ? 0.01 : num * 1;
  str = str.toLocaleString() + '';
  let rs = str.indexOf('.');
  if (rs < 0) {
    rs = str.length;
    str += '.';
  }
  while (str.length <= rs + 2) {
    str += '0';
  }
  return str;
};
// 数值显示方式
export const getLongNum = value => {
  return (value * 1).toLocaleString();
};
export const getNumberShowValue = (value, fixed = 2) => {
  // const val = Math.round((value ? value * 1 : 0) * Math.pow(10, fixed)) / Math.pow(10, fixed);
  const val = value ? value * 1 : 0;
  if (val >= 100000000 || val <= -100000000) {
    const num = Math.round((val / 100000000) * Math.pow(10, fixed)) / Math.pow(10, fixed);
    return num.toLocaleString() + '亿';
  } else if (val >= 10000 || val <= -10000) {
    const num = Math.round((val / 10000) * Math.pow(10, fixed)) / Math.pow(10, fixed);
    return num.toLocaleString() + '万';
  } else {
    const num = val;
    return num.toLocaleString();
  }
};

export const getNumberShowValue2 = (value, fixed = 2) => {
  // const val = Math.round((value ? value * 1 : 0) * Math.pow(10, fixed)) / Math.pow(10, fixed);
  const val = value ? value * 1 : 0;
  if (val >= 100000000 || val <= -100000000) {
    const num = Math.round((val / 100000000) * Math.pow(10, fixed)) / Math.pow(10, fixed);
    return {
      value: num.toLocaleString(),
      unit: '亿',
    };
  } else if (val >= 10000 || val <= -10000) {
    const num = Math.round((val / 10000) * Math.pow(10, fixed)) / Math.pow(10, fixed);
    return {
      value: num.toLocaleString(),
      unit: '万',
    };
  } else {
    const num = val;
    return {
      value: num.toLocaleString(),
      unit: '',
    };
  }
};
/**
 * @name 钱显示方式
 * @param {*} value
 * @returns
 */
export const getMoneyShowValue = (value, fixed = 2) => {
  // const val = Math.round((value ? value * 1 : 0) * Math.pow(10, fixed)) / Math.pow(10, fixed);
  const val = value ? value * 1 : 0;
  if (val >= 100000000 || val <= -100000000) {
    const num = Math.round((val / 100000000) * Math.pow(10, fixed)) / Math.pow(10, fixed);
    return toDecimal2(num, val) + '亿';
  } else if (val >= 10000 || val <= -10000) {
    const num = Math.round((val / 10000) * Math.pow(10, fixed)) / Math.pow(10, fixed);
    return toDecimal2(num, val) + '万';
  } else {
    const num = val;
    return toDecimal2(num, val);
  }
};

export const getMoneyShowValue2 = (value, fixed = 2) => {
  // const val = Math.round((value ? value * 1 : 0) * Math.pow(10, fixed)) / Math.pow(10, fixed);
  const val = value ? value * 1 : 0;
  if (val >= 100000000 || val <= -100000000) {
    const num = Math.round((val / 100000000) * Math.pow(10, fixed)) / Math.pow(10, fixed);
    return {
      value: toDecimal2(num, val),
      unit: '亿',
    };
  } else if (val >= 10000 || val <= -10000) {
    const num = Math.round((val / 10000) * Math.pow(10, fixed)) / Math.pow(10, fixed);
    return {
      value: toDecimal2(num, val),
      unit: '万',
    };
  } else {
    const num = val;
    return {
      value: toDecimal2(num, val),
      unit: '',
    };
  }
};

export const getNumberYuan = (value, fixed = 2) => {
  const val = value ? value * 1 : 0;
  let num = Math.round(val * Math.pow(10, fixed)) / Math.pow(10, fixed);
  num = !num && val ? 0.01 : num;
  return num.toLocaleString();
};

export const getMoneyYuan = (value, fixed = 2) => {
  const val = value ? value * 1 : 0;
  const num = Math.round(val * Math.pow(10, fixed)) / Math.pow(10, fixed);
  return toDecimal2(num, val);

};

export const getMoneyWan = (value, fixed = 2) => {
  const val = value ? value * 1 : 0;
  const num = Math.round((val / 10000) * Math.pow(10, fixed)) / Math.pow(10, fixed);
  return toDecimal2(num, val) + '万';
};

export const getMoneyWan2 = (value, fixed = 2) => {
  const val = value ? value * 1 : 0;
  const num = Math.round((val / 10000) * Math.pow(10, fixed)) / Math.pow(10, fixed);
  return toDecimal2(num, val);
};

export const getMoneyYi = (value, fixed = 2) => {
  const val = value ? value * 1 : 0;
  const num = Math.round((val / 100000000) * Math.pow(10, fixed)) / Math.pow(10, fixed);
  return toDecimal2(num, val) + '亿';
};

export const getMoneyYi2 = (value, fixed = 2) => {
  const val = value ? value * 1 : 0;
  const num = Math.round((val / 100000000) * Math.pow(10, fixed)) / Math.pow(10, fixed);
  return toDecimal2(num, val);
};
/**
 * @name 百分比显示
 * @param {*} value
 */
export const getPercentageShow = value => {
  return Math.round(((value * 1) / 100) * 10000) / 100 + '%';
};

export const getPercentageShow2 = value => {
  const num = Math.round(((value * 1) / 100) * 10000) / 100;
  return num.toFixed(2) + '%';
};

const realWidth = window.innerWidth;
export const designPxToRealPx = (designPx, needPxString = true) => {
  const realPx = (designPx / 375) * realWidth;
  return needPxString ? realPx + 'px' : realPx;
};

export const designPxToRealVw = (designPx, needVwString = true) => {
  const realVw = designPx / 3.75;
  return needVwString ? realVw + 'vw' : realVw;
};

/**
 * 获取最近几月xLabel日期
 * @param { } month Number
 * @param { } formatter yyyy/MM/dd hh:mm:ss
 * @returns String
 */
export const getXLabelMonthDataList = (month = 7, formatter = 'yyyy/MM/dd') => {
  const now = new Date().getTime();
  const oneMonthTime = 3600 * 24 * 1000 * 31;
  return Array.from(Array(month), (v, k) =>
    dateFormat(now - k * oneMonthTime, formatter)
  ).reverse();
};

/**
 * 获取最近几天xLabel日期
 * @param { } day Number
 * @param { } formatter yyyy/MM/dd hh:mm:ss
 * @param { } currentTime 当前时间开始
 * @returns String
 */
export const getXLabelDataList = (day = 7, formatter = 'yyyy/MM/dd', currentTime = '') => {
  const now = currentTime ? new Date(currentTime).getTime() : new Date().getTime();
  const oneDayTime = 3600 * 24 * 1000;
  return Array.from(Array(day), (v, k) => dateFormat(now - k * oneDayTime, formatter)).reverse();
};

/**
 * 获取最近24小时的xLabel数据
 * @param { } count Number 需要生成的数据量
 * @param { } interval Number 间隔的时间
 * @param { } formatter hh:mm:ss
 * @returns String
 */
export const get24HourXLabelData = (count, interval = 2, formatter = 'hh:mm') => {
  const now = new Date().getTime();
  const intervalTime = 3600 * interval * 1000; // 间隔的时间-毫秒数
  return Array.from(Array(count), (v, k) =>
    dateFormat(now - k * intervalTime, formatter)
  ).reverse();
};

/**
 * 获取随机生成趋势图柱状图数据
 * @param { } minVal 随机数起步值
 * @param { } randomNumber xx以内随机数
 * @param { } decimal 生成的小数位
 * @returns Number
 */
export const getLineDataList = ({ minVal = 400, randomNumber = 800, decimal = 0, day = 365 }) => {
  return Array.from(Array(day), () => {
    if (decimal) {
      return +(window.$Random01() * randomNumber + minVal).toFixed(decimal);
    } else {
      return parseInt(window.$Random01() * randomNumber) + minVal;
    }
  });
};

// 定义函数，判断两个对象是否相同
export const isSameObject = (obj1, obj2, keyName) => {
  if (keyName) {
    return obj1?.[keyName] === obj2?.[keyName];
  } else {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }
};

// 定义函数，用于获取两个数组的交集
export const getArrayIntersection = (arr1, arr2, keyName) => {
  let intersection = [];

  for (let i = 0; i < arr1.length; i++) {
    for (let j = 0; j < arr2.length; j++) {
      if (isSameObject(arr1[i], arr2[j], keyName)) {
        intersection.push(arr1[i]);
        break; // 找到相同对象后就停止比较
      }
    }
  }

  return intersection;
};

/**
 * 合并两个树，返回交集树
 */
export const getIntersectionTree = (tree1, tree2, keyName) => {
  // 示例层级树1
  // let tree1 = {
  //   val: 1,
  //   child: [{
  //       id: 2,
  //       val: 2,
  //       child: [{
  //       id: 22,
  //       val: 22,
  //   }]
  //   },{
  //       id: 3,
  //       val: 3,
  //   }],
  // };

  // // 示例层级树2
  // let tree2 = {
  //   val: 1,
  //   child: [{
  //       id: 2,
  //       val: 2,
  //       child: [{
  //       id: 22,
  //       val: 22,
  //   }]
  //   },{
  //       id: 4,
  //       val: 4,
  //   }],
  // };
  if (!tree1 || !tree2) {
    return null;
  }

  let intersection = {};

  for (let key in tree1) {
    if (key in tree2) {
      if (Array.isArray(tree1[key]) && Array.isArray(tree2[key])) {
        // 如果是数组
        intersection[key] = getArrayIntersection(tree1[key], tree2[key], keyName);
      } else if (typeof tree1[key] === 'object' && typeof tree2[key] === 'object') {
        // 如果是对象
        intersection[key] = getIntersectionTree(tree1[key], tree2[key], keyName);
      } else if (isSameObject(tree1[key], tree2[key], keyName)) {
        // 如果是对象，并且相等
        intersection[key] = tree1[key];
      }
    }
  }

  return intersection;
};
/**
 * @name 获取url请求参数
 */
export const getURLSearchParams = () => {
  let ret = {};
  const arr = window.location.href.split('?');
  if (arr[1]) {
    let searchParams = new URLSearchParams(arr[1]);
    for (let [key, value] of searchParams) {
      ret[key] = value;
    }
  }

  return ret;
};
/**
 * @name 获取url所有请求参数（含拼接在#前后的）
 */
export const getAllURLSearchParams = () => {
  let ret = {};
  const arr = window.location.href.split('?');
  if (arr[1]) {
    const searchParams1 = new URLSearchParams(arr[1]);
    for (let [key, value] of searchParams1) {
      ret[key] = value;
    }
  }
if (arr[2]) {
    const searchParams2 = new URLSearchParams(arr[2]);
    for (let [key, value] of searchParams2) {
      ret[key] = value;
    }
  }
  return ret;
};